<mat-sidenav-container class="sidenav-container" color="primary">
  <mat-sidenav #sidenav mode="side" [opened]="isAuth ? 'true' : 'false'">
    <mat-nav-list>
      <a mat-list-item *ngFor="let menu of menuList" [routerLink]="MenuItemRoute.get(menu)"
        routerLinkActive="active-link">
        <mat-icon>{{MenuItemIcon.get(menu)}}</mat-icon> {{ 'nav.' + MenuItemName.get(menu) | translate }}
      </a>
    </mat-nav-list>
    <div class="app-footer">
      <img src="assets/img/bizzdev.png" class="app-footer-img">
      Version: {{versionApp}}
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div style="height: 100%;">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>